import axios from 'axios'

axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.withCredentials = true
axios.defaults.credentials = 'same-origin'

export const HTTP = axios.create({
  baseURL: 'https://app.focusmt.de/api/v1/'
})
